var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useRef, useState } from 'react';
import ImageFileUtils, { UploadCancelledError, } from '@/utils/ImageFileUtils';
import ToastUtils from '@/utils/ToastUtils';
const HIDDEN_PROPS = {
    visible: false,
    stage: 'uploading',
    currentIndex: 0,
    totalImages: 0,
    progress: 0,
    imageSizeMb: 0,
};
/** 업로드 실패 토스트 — 사용자가 직접 취소한 건 실패로 말하지 않는다. 폼 입력은 그대로 남는다. */
export function showUploadFailedToast(error) {
    ToastUtils.show(error instanceof UploadCancelledError
        ? '사진 업로드를 취소했어요. 다시 등록해주세요.'
        : '사진 업로드를 실패했습니다.');
}
export function useImageUploadWithProgress() {
    const [overlayProps, setOverlayProps] = useState(HIDDEN_PROPS);
    const abortControllerRef = useRef(null);
    const cancel = useCallback(() => { var _a; return (_a = abortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort(); }, []);
    const uploadImages = useCallback((api, images, purposeType, label) => __awaiter(this, void 0, void 0, function* () {
        const abortController = new AbortController();
        abortControllerRef.current = abortController;
        try {
            return yield ImageFileUtils.uploadImages(api, images, purposeType, (p) => {
                setOverlayProps({
                    visible: true,
                    stage: p.stage,
                    currentIndex: p.currentIndex,
                    totalImages: p.totalImages,
                    progress: p.totalBytes > 0 ? p.bytesUploaded / p.totalBytes : 0,
                    imageSizeMb: p.imageSizeMb,
                    label,
                });
            }, abortController.signal);
        }
        finally {
            abortControllerRef.current = null;
            setOverlayProps(prev => (Object.assign(Object.assign({}, prev), { visible: false })));
        }
    }), []);
    return { uploadImages, uploadProgress: Object.assign(Object.assign({}, overlayProps), { onCancel: cancel }) };
}
